import {HttpErrorResponse, HttpInterceptorFn} from "@angular/common/http";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {ErrorHandlerService} from "@shared/api";
import {catchError, retry, throwError, timer} from "rxjs";
import {MessageService} from "primeng/api";

const MAX_RETRY_ATTEMPTS = 2;

export const errorsInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const errorHandler = inject(ErrorHandlerService);
    const messages = inject(MessageService);

    return next(req).pipe(
        retry({
            count: MAX_RETRY_ATTEMPTS,
            delay: (error: HttpErrorResponse, retryCount) => {
                if (error.status !== 0 || !(error.status >= 400 && error.status < 500)) {
                    throw error;
                }
                return timer(1000 * retryCount);
            }
        }),
        catchError((err: HttpErrorResponse) => {
            switch (err.status) {
                case 0:
                    messages.add({
                        severity: "error",
                        summary: "Нет соединения с сервером",
                        detail:
                            "Связь с сервером прервана. Проверьте подключение к интернету или обратитесь к администратору."
                    });
                    break;

                case 403:
                    router.navigate(["/403"]).then(() =>
                        console.error("У вас нет доступа к запрашиваемому ресурсу.")
                    );
                    break;

                case 500:
                case 503:
                case 504:
                    messages.add({
                        severity: "error",
                        summary: "Ошибка сервера",
                        detail: "Сервис временно недоступен. Пожалуйста, зайдите позднее."
                    });
                    break;

                default:
                    errorHandler.handleHttpError(err);
                    break;
            }

            return throwError(() => err);
        })
    );
};
